import styled from "styled-components";

export const Container = styled.div`
  direction: rtl;
  /* margin-top: -5px;
  margin-left: 20px;
  margin-bottom: 10px; */
  display: flex;
  align-items: center;
`;

export const Element = styled.input`
  width: 24px;
  height: 24px;
  cursor: pointer;
  border: 1px solid var(--bg-gray);
  border-radius: 4px;
  input[type="checkbox"] {
    accent-color: #08452f !important;
    border: 2px solid red;
  }
`;

export const Label = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  margin-right: 8px;
  color: var(--text-400);
  /* color: ${(props) => props.fontColor}; */
  cursor: pointer;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`;
